import React from 'react';
import { Redirect } from 'react-router-dom';
import get from 'lodash/get';

import { PLACEHOLDER_OPT } from '../Forms/Schemas/baseRrf';


const Big = require('big.js/big.js');


// returns false if no redirect is necessary
const redirectByFormValidation = (
  currentPath,
  formData,
  offer,
  cashBalance,
  pendingTransfers,
  accountRestrictions,
) => {
  const splitPath = currentPath.split('/');
  const finalPath = splitPath.slice(-1)[0];
  const cleanUrl = splitPath.slice(0, (splitPath.length - 1)).join('/');

  const shareQuantityOrTotalInvestment = get(formData, 'offerOrderAmount.quantity') || get(formData, 'offerOrderAmount.totalInvestment');

  switch (finalPath) {
    case 'amount':
      // FINRA restricted accounts can't invest
      if (accountRestrictions.length > 0) {
        return <Redirect to={`${cleanUrl}/account-restriction`} />;
      }
      return false;

    case 'disclosures':
      if (shareQuantityOrTotalInvestment &&
        (!offer.allowRestrictedPersons || get(formData, 'offerOrderAmount.unrestricted'))) {
        return false;
      }
      return <Redirect to={`${cleanUrl}/amount`} />;

    case 'payment':
      if (!(shareQuantityOrTotalInvestment) ||
          (offer.allowRestrictedPersons && !get(formData, 'offerOrderAmount.unrestricted'))) {
        return <Redirect to={`${cleanUrl}/amount`} />;
      } else if (!get(formData, 'offerOrderDisclosures.reviewedDocuments', false)) {
        return <Redirect to={`${cleanUrl}/disclosures`} />;
      }
      return false;

    case 'review-order':
      if (!(shareQuantityOrTotalInvestment) ||
          (offer.allowRestrictedPersons && !get(formData, 'offerOrderAmount.unrestricted'))) {
        return <Redirect to={`${cleanUrl}/amount`} />;
      } else if (!get(formData, 'offerOrderDisclosures.reviewedDocuments', false)) {
        return <Redirect to={`${cleanUrl}/disclosures`} />;
      } else if (
        (Big(cashBalance).plus(pendingTransfers).lt(Big(get(formData, 'offerOrderAmount.quantity', 0)).times(offer.pricePerShare)) ||
         Big(cashBalance).plus(pendingTransfers).lt(Big(get(formData, 'offerOrderAmount.totalInvestment', 0)))) &&
                (
                  !get(formData, 'offerOrderTransferFunds.from', false) ||
                  get(formData, 'offerOrderTransferFunds.from') === PLACEHOLDER_OPT
                )
      ) {
        return <Redirect to={`${cleanUrl}/payment`} />;
      }
      return false;

    default:
      return false;
  }
};

export default redirectByFormValidation;



// WEBPACK FOOTER //
// ./src/components/Invest/redirectByFormValidation.js